/**
 * Generated country agency route paths — all English + translated slugs
 * Used by App.tsx to register all country agency landing page routes dynamically.
 */
import { COUNTRY_AGENCY_PAGES } from '@/data/country-agency-pages';
import { TRANSLATED_AGENCY_SLUGS } from '@/data/country-agency-slug-translations';

/** All unique country agency page slugs (English + translated) */
export function getAllAgencyRouteSlugs(): string[] {
  const slugs = new Set<string>();

  // English slugs from data
  for (const data of Object.values(COUNTRY_AGENCY_PAGES)) {
    slugs.add(data.slug);
  }

  // Translated slugs from all languages
  for (const langMap of Object.values(TRANSLATED_AGENCY_SLUGS)) {
    for (const slug of Object.keys(langMap)) {
      slugs.add(slug);
    }
  }

  return Array.from(slugs);
}

export const ALL_AGENCY_ROUTE_SLUGS = getAllAgencyRouteSlugs();
